import ChatColumnController from '../chat_column/component_controller'

// コラムEF「自己負担シミュ」（#13984）
// 現行コラムEFのStimulusコントローラを継承する。分岐（data-condition）・エリア連動・順位付き保存などの挙動は
// 現行と同一であることが受け入れ条件のため、現行JSは変更せず、このクラスには次の3点だけを持つ。
//   (1) 新規設問用ハンドラの追加（nextChatWithScrollEnableCondition）
//   (2) 出題順（Issue #13984 表1）に依存する遷移の差し替え（こだわり条件 nextChatWithConditionWant・重視度 nextChatWithConditionWantQuestions）
//   (3) 設問文の差し替え（表2）のうちJS側に文言があるもの（現況による一人暮らし設問の書換）
export default class extends ChatColumnController {
  // slim とJSの結線ミス（属性の付け忘れ・条件名のタイポ等）は例外を出さずフォームが完走してしまい、保存値の欠損として静かに残る。
  // 開発時は console、本番では Sentry（親クラスと同じく読み込まれていれば）で気づけるようにする
  reportWiringIssue (operation, message) {
    console.warn(`[chat_column_cost] ${operation}: ${message}`)
    if (typeof Sentry !== 'undefined') {
      Sentry.captureMessage(`[chat_column_cost] ${operation}: ${message}`, { level: 'warning', tags: { component: 'inquiry-chat-column-cost', operation } })
    }
  }

  // 押された選択肢に data-enable-condition があれば、その条件付き設問（data-condition）を有効化してから次へ進む。
  // 現状は住民税非課税（seq5）の「わからない」→ 代理質問（seq6）で使用。他の設問でも属性を付ければ同じ動きになる
  nextChatWithScrollEnableCondition (e) {
    const condition = e.currentTarget.dataset.enableCondition
    if (condition) {
      // 条件名のタイポで対象ブロックが無いと、代理質問が誰にも出ないまま進んでしまう
      if (!this.formTarget.querySelector(`[data-condition="${condition}"]`)) this.reportWiringIssue('enable-condition', `対象ブロックが無い: ${condition}`)
      this.enableCondition(condition)
    } else {
      // このハンドラを付けたのに data-enable-condition が無い（付け忘れ・属性名のタイポ）と、素の nextChatWithScroll に退化して代理質問が誰にも出ない
      this.reportWiringIssue('enable-condition', `data-enable-condition が無い選択肢から呼ばれた: ${e.currentTarget.name || e.currentTarget.outerHTML.slice(0, 80)}`)
    }
    this.hideCurrentChatInput(e)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  // Issue #13984 表2: ご状況が在宅系（Inquiry::CurrentState 4〜6）のとき親クラスが innerHTML に入れる
  // 「入居希望者は一人暮らしですか？」を「入居検討者は…」に差し替える（呼称は現行から意図的に変更。#13984 プランナー回答 2026-09-09）。connect() の事前入力経路（e = null）でも同じ順で呼ばれる
  nextChatWithChoseCurrentStatus (e, options = {}) {
    super.nextChatWithChoseCurrentStatus(e, options)

    const currentStatusValue = this.formTarget.elements['inquiry[occupant_current_status_id]'].value
    if (currentStatusValue === '4' || currentStatusValue === '5' || currentStatusValue === '6') {
      this.occupantCurrentStatusLivingaloneTextAllTargets.forEach(elm => {
        elm.innerHTML = '入居検討者は一人暮らしですか？'
      })
    }
  }

  // こだわり条件（seq71）。親クラスの同名メソッドの複製で、差分は次の3点のみ（それ以外は親と同じ処理）
  //   - 「特になし・回答しない」（condition_want_gradation10）単独選択時に送信ボタンを表示する nextChatWithSubmitBefore2 を呼ばない（新順序では後ろに設問が続く）
  //   - 現行のメッセージ専用ブロック（condition_want_gradation_balloon）は本ページに無いため、その有効化を省く
  //   - チェック0件で呼ばれたときの早期 return（親は checkedElements[0] の参照で TypeError になる）
  // 親にフックを切って差分だけ上書きする形は、現行EFのJSを本PRで変更しない方針（現行との同一挙動が受け入れ条件）のため見送り。
  // 5本化の2本目以降で同じ複製が増える時点で親側にフック（送信ボタン表示の要否・メッセージ専用ブロックの条件名）を切る
  // ⚠️ 親の nextChatWithConditionWant（重視度ブロックの firstQuestion / normalQuestion の除去ロジック）を変更したら、ここにも同じ変更を反映すること
  nextChatWithConditionWant (e) {
    const checkedTitles = []
    const checkedElements = Array.from(this.formTarget.elements['inquiry[extra_input_params][condition_want][]']).filter(el => el.checked)
    // 「次へ」は1つ以上チェックされるまで disabled なので通常は到達しない。到達した場合、親は TypeError（Sentry に上がる）で止まるが、
    // ここで黙って return すると無音の行き止まりになるため、通知を残したうえで止める（disabled 制御や action 指定が外れた事故の検知用）
    if (checkedElements.length === 0) {
      this.reportWiringIssue('condition-want', 'チェックされた選択肢が無いまま「次へ」が呼ばれた')
      return
    }

    const condition = checkedElements[0].dataset.condition
    if (checkedElements.length === 1 && condition && condition === 'condition_want_gradation10') {
      this.hideCurrentChatInput(e, `${checkedElements[0].dataset.title}です`)
      this.showNextChat(e.currentTarget.dataset.next)
      return
    }

    checkedElements.forEach((el, index) => {
      const condition = el.dataset.condition

      if (condition && condition !== 'condition_want_gradation10') {
        this.enableCondition(condition)
      }

      if (index === 0) {
        Array.from(this.normalQuestionTargets).forEach(target => {
          const parent = target.closest('[data-condition]')
          if (parent && parent.dataset.condition === condition) {
            target.remove()
          }
        })
      } else {
        Array.from(this.firstQuestionTargets).forEach(target => {
          const parent = target.closest('[data-condition]')
          if (parent && parent.dataset.condition === condition) {
            target.remove()
          }
        })
      }
      checkedTitles.push(el.dataset.title)
    })

    const valueText = checkedTitles.join('、')
    this.hideCurrentChatInput(e, `${valueText}、です`)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  // 重視度（seq72〜80）。親クラスは「最後にチェックした重視度か」を判定し、最後なら showNextChatOnly（メッセージ専用ブロック＋次問のペア表示）と
  // 送信ボタン表示を行う。本ページにはメッセージ専用ブロックが無く、seq80 の直後は条件付きでない seq81 なので showNextChat の skip 走査で
  // 自然に次の設問へ到達する。そのため「最後か」の判定自体が不要になり、常に通常の遷移にしている（判定漏れではない）
  nextChatWithConditionWantQuestions (e) {
    this.hideCurrentChatInput(e, e.currentTarget.dataset.text)
    this.showNextChat(e.currentTarget.dataset.next)
  }
}
